import type { ListBuilderList } from '../../../types';
import { AGING_REQUIRED_FIELDS, BASE_FILTER_RULES } from '../shared';

/**
 * Past due 61-90 days - outstanding invoices 61 to 90 days past due
 */
export const pastDue61To90List: ListBuilderList = {
	id: 'default-invoices-past-due-61-90',
	inheritsFrom: 'default-invoices-all',
	cacheTTL: 600000,
	name: 'Past Due 61-90',
	type: 'default',
	active: true,
	sortOrder: 5,
	description: 'Outstanding invoices 61 to 90 days past due',
	defaultSortId: 'date-asc',
	requiredFields: AGING_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		invoicePaymentStatus: {
			defaultValue: [{ id: 'outstanding', label: 'Outstanding' }],
		},
		invoiceDueDateRange: {
			defaultValue: [
				{
					id: 'past-due-61-90',
					label: '61-90 Days Past Due',
					data: {
						startDate: '{{DATE:-90d}}',
						endDate: '{{DATE:-61d}}',
					},
				},
			],
		},
		// Clear the default 90-day invoice date filter so all matching invoices show
		invoiceDateRange: {
			defaultValue: [],
		},
	},
};
